<ng-container>
  <qrcode
    [qrdata]="value"
    [elementType]="elementType"
    [errorCorrectionLevel]="errorCorrectionLevel"
    [width]="width"
    [margin]="margin"
  ></qrcode>
  <button *ngIf="showDownloadBtn" (click)="downloadQRCode()">Download</button>
</ng-container>
